import { render, staticRenderFns } from "./NewCarDetail.vue?vue&type=template&id=7340e6fa&scoped=true&"
import script from "./NewCarDetail.vue?vue&type=script&lang=js&"
export * from "./NewCarDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewCarDetail.vue?vue&type=style&index=0&id=7340e6fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7340e6fa",
  null
  
)

export default component.exports